import { useClientExtraLargeScreen } from '@/lib/user-agent/client';

import { PRODUCT_TABS } from '@/components/app/product/components/@shared/type';

import localization, { pageLevelLocalization } from '@/constant/localization';

import ContentIcon from '~/images/icons/content-icon';
import MessageIcon from '~/images/icons/message-icon';
import MessageQuestionIcon from '~/images/icons/messageQuestionIcon';
import MessageStarIcon from '~/images/icons/messageStarIcon';
import MessageText from '~/images/icons/messageText';
import Shope from '~/images/icons/shope';

const { product: productLocalization } = pageLevelLocalization;

export function useTableContentItems({
  hasReviews,
  hasQuestions,
}: {
  hasReviews: boolean;
  hasQuestions: boolean;
}) {
  const isExtraLarge = useClientExtraLargeScreen();

  const items = [
    {
      icon: <Shope width={isExtraLarge ? '20' : '14'} color='currentColor' />,
      title: productLocalization.productSpecifications,
      sectionId: 'productSpecifications',
      key: 'productSpecifications',
      tab: PRODUCT_TABS.CONTENT,
    },
    {
      icon: <ContentIcon width={isExtraLarge ? '20' : '12'} color='currentColor' />,
      title: productLocalization.content,
      tab: PRODUCT_TABS.CONTENT,
      key: 'productDescriptionSection',
      sectionId: 'productDescriptionSection',
    },
    {
      icon: <MessageText width={isExtraLarge ? '20' : '15'} color='currentColor' />,
      title: productLocalization.productChangelog,
      sectionId: 'productChangelogSection',
      key: 'productChangelogSection',
      tab: PRODUCT_TABS.CONTENT,
    },
    {
      icon: <MessageStarIcon width={isExtraLarge ? '20' : '14'} color='currentColor' />,
      title: productLocalization.comments,
      tab: PRODUCT_TABS.CONTENT,
      key: 'commentsSection',
      sectionId: 'commentsSection',
    },
    {
      icon: <MessageQuestionIcon width={isExtraLarge ? '20' : '14'} color='currentColor' />,
      title: productLocalization.questions,
      sectionId: 'questionsSection',
      key: 'questionsSection',
      tab: PRODUCT_TABS.CONTENT,
    },
    {
      icon: <MessageIcon width={isExtraLarge ? '20' : '14'} color='currentColor' />,
      title: localization.faq,
      sectionId: 'faqSection',
      key: 'faqSection',
      tab: PRODUCT_TABS.CONTENT,
    },
  ];

  return items.filter((item) => {
    if (!hasReviews && item.key === 'commentsSection') return false;
    if (!hasQuestions && item.key === 'questionsSection') return false;
    return true;
  });
}
